export enum ReferencedTables {
	Employee = 1,
	Position = 2,
	Supplement = 3,
	ReclassifyBatch = 4,
	EmployeeStaffAction = 5,
	Asset = 6,
	EmployeeCeu = 7,
	Workshop = 8,
}
